import { EdiFuncAck } from "../EdiFuncAck";
import { EdiMapErrors } from "../EdiMapErrors";
import { Checkbox, DataSource, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutViewEdiBilling extends Layout {
    checkBalanceDue: Checkbox;
    checkRebill: Checkbox;
    checkboxIntercompany: Checkbox;
    labelEditWarning: Label;
    labelFuncAck: Label;
    layoutEdiFunctionalAck: EdiFuncAck;
    layoutMapErrors: EdiMapErrors;
    panelFuncAck: Panel;
    panelMain: Panel;
    sourceEdiBilling: DataSource;
    sourceEdiFunctionalAck: DataSource;
    sourceEdiMapError: DataSource;
    switchTransmit: Switch;
    tabErrors: Tab;
    tabsetErrors: Tabset;
    textReadyToSend: Textbox;
    textboxBlnum: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityDescr: Textbox;
    textboxConsigneeRefNo: Textbox;
    textboxPartnerName: Textbox;
    textboxPieces: Textbox;
    textboxTransmitted: Textbox;
    textboxWeight: Textbox;
    txtBatch: Textbox;
    txtCorrectionIndicator: Textbox;
    txtCreateDate: Textbox;
    txtDirection: Textbox;
    txtError: Textbox;
    txtId: Textbox;
    txtModifiedDate: Textbox;
    txtModifiedUser: Textbox;
    txtServiceCode: Textbox;
    txtShipmentId: Textbox;
}
